export const requiredOpenFrameMetaTags = [
  'of:version',
  /^of:accepts:/,
  'of:image',
  'og:image',
];
